import { loadPublicAuthState } from '~/publicAuth';

interface AnalyticsPayload {
    [key: string]: unknown;
}

interface ProductTracker {
    track: (payload: (defaults: AnalyticsPayload) => AnalyticsPayload) => void | Promise<unknown>;
}

export async function trackQualifiedListen(): Promise<void> {
    if (typeof window === 'undefined') return;
    try {
        const { authenticated, user } = await loadPublicAuthState(true);
        const id = authenticated ? user?.analytics_id : null;
        const umami = (window as Window & { umami?: ProductTracker }).umami;
        if (!id || !umami) return;

        await umami.track((defaults) => ({
            ...defaults,
            id,
            url: '/listen',
            referrer: '',
            title: 'Player',
            name: 'listener-qualified',
            data: {
                account_id: id,
                area: 'player',
                signed_in: true,
                seconds: 30,
                schema_version: 1,
            },
        }));
    } catch {
        // Analytics must never interrupt playback.
    }
}
